export const FETCH_WATERFALL_MAPPINGS_BY_DATASET = 'FETCH_WATERFALL_MAPPINGS_BY_DATASET';
export const FETCH_WATERFALL_MAPPINGS_BY_DATASET_FV ='FETCH_WATERFALL_MAPPINGS_BY_DATASET_FV';
// export const BUSINESS_FUNCTIONS_UPDATE_DEFAULT_MAPPINGS = 'BUSINESS_FUNCTIONS_UPDATE_DEFAULT_MAPPINGS';
// export const BUSINESS_FUNCTIONS_FETCH_COLUMNS_BY_DATASETID = 'BUSINESS_FUNCTIONS_FETCH_COLUMNS_BY_DATASETID';
// export const CLEAR_BUSINESS_FUNCTION_COLUMNS_BY_DATASET_ID = 'CLEAR_BUSINESS_FUNCTION_COLUMNS_BY_DATASET_ID';
